import React from 'react';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';

const EmptyStateListItem = () => {
  return (
    <Stack
      alignItems="stretch"
      className={cn('w-full h-full p-8')}
      direction="row"
      gapX={12}></Stack>
  );
};

export default EmptyStateListItem;
